import { store, store$ } from '@redux/store';
import { routingStateActions } from 'features/routing';
import { map, distinctUntilChanged, filter, skip } from 'rxjs';
import { selectPage } from 'features/articleSearchResultsFacets';

/**
 * Updates the URL with the appropriate paging segment based on the provided page number.
 * This function constructs a paging segment for the URL following the business rule
 * of the news and trends, which requires all URLs to end with a "/". If the page number
 * is greater than 1, the paging segment will be in the format `page-{pageNumber}/`.
 * Otherwise, it will be an empty string. The constructed paging segment is then
 * dispatched to update the routing state.
 * 
 * @param {number} pageNumber - The current page number. Must be a positive integer.
 */
const updateUrlPaging = (pageNumber) => {
  
  // add "/" by business rule of the news and trends (all url has / to the end)
  const pagingSegment = pageNumber > 1 ? `page-${pageNumber}/` : '';
  store.dispatch(routingStateActions.updatePagination(pagingSegment));
};

// observer to map search command but only emmit if the page have been changed
const onPageChange$ = store$.pipe(
  map(selectPage),
  filter(Boolean),
  distinctUntilChanged(),
  skip(1)
);
  
onPageChange$.subscribe(updateUrlPaging);

